<div class="page-container book-management-container container">
  <div class="row w-100 m-0">
    <app-utility-toolbar
      class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
      [current]="current"
      [vertical]="true"
      [links]="bmLinks"
      (toggleCollapse)="toggleNavCollapse()"
    />

    <div class="content-container pl-3" [ngClass]="{ collapsed: navCollapsed }">
      <!-- <app-bm-widget-filters
        [viewMode]="current === 'office-view' ? 'ho' : 'rep'"
      /> -->
      @if (current === 'office-view') {
        <app-home-office-reports />
      } @else if (current === 'rep-reports') {
        <app-rep-reports />
      } @else if (current !== 'office-view' && current !== 'rep-reports') {
        @if (!policyId) {
          <app-rb-grid
            [gridConfig]="gridConfig"
            [getSetup]="getGridSetup"
            [getData]="getGridData"
          >
            <button
              type="button"
              mat-raised-button
              color="primary"
              class="header-button"
              matTooltip="Limit 100,000"
              matTooltipPosition="above"
              [disabled]="fileLoading"
              (click)="downloadPolicyList()"
            >
              <span class="button-label-with-icon">
                @if (fileLoading) {
                  <mat-spinner diameter="20" />
                } @else {
                  <mat-icon>cloud_download</mat-icon>
                }
                Download Policy List
              </span>
            </button>
            @if (launchButton && launchButton.ShowLaunchButton) {
              <button
                type="button"
                mat-raised-button
                color="primary"
                class="custom-grid-control me-0 ms-2 mb-2"
                [disabled]="disableLaunchTo()"
                (click)="launchToCase(launchButton.LaunchLocation)"
              >
                <mat-icon>rocket_launch</mat-icon>
                {{ launchButton.LaunchButtonLabel }}
              </button>
            }
          </app-rb-grid>
        } @else {
          <app-policy-details
            [policyId]="policyId"
            [launchButton]="launchButton"
          />
        }
      }
    </div>
  </div>
</div>
